 // For running the application locally, please update the below values with your local SSO configuration
 
const APPCONFIG = {
  apiKey: process.env.REACT_APP_API_KEY, //"d9c3281973c34087a69b109bf34234fb"
  apiBaseURL: process.env.REACT_APP_API_BASE_URL, // "https://apidv.digitalag.farm/
  arcGisClientId: process.env.REACT_APP_ARCGIS_CLIENT_ID, //"mOVtleAZwF9iJivD",
  arcGisPortalUrl: process.env.REACT_APP_ARCGIS_PORTAL_URL, // "https://landolakes.maps.arcgis.com",
  arcGISSharedGroupIds: process.env.REACT_APP_ARCGIS_SHARED_GROUP_IDS, // "b1c0d2f3e4f54a8b9c0d2f3e4f54a8b9",
  maintenanceStartTime: process.env.REACT_APP_MAINTENANCE_START_TIME, 
  maintenanceEndTime: process.env.REACT_APP_MAINTENANCE_END_TIME,
  maintenanceStartDate: process.env.REACT_APP_MAINTENANCE_START_DATE, 
  maintenanceEndDate: process.env.REACT_APP_MAINTENANCE_END_DATE,
  isUnderMaintenance: process.env.REACT_APP_IS_UNDER_MAINTENANCE === "true",
  environment: process.env.REACT_APP_ENVIRONMENT, // 'dev', 'qa', 'prod', etc.
};
export default APPCONFIG;